import { render } from "./NavigationArrows.vue?vue&type=template&id=2e33bd22&scoped=true"
import script from "./NavigationArrows.vue?vue&type=script&lang=js"
export * from "./NavigationArrows.vue?vue&type=script&lang=js"

import "./NavigationArrows.vue?vue&type=style&index=0&id=2e33bd22&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e33bd22"]])

export default __exports__